import type { JSX } from "react";

import { Alert, Box, MenuItem, Select } from "@mui/material";

import { language } from "@/Router";
import { useConfigurationServiceGetConfigurators } from "@/openapi/api-pc/queries/queries";

export function CFGObjectSelect(): JSX.Element {
  const { data } = useConfigurationServiceGetConfigurators();

  const cfgObjects = data?.map((cfg) => cfg.id);

  const fastConfiguration = window.sessionStorage.getItem("fastConfiguration");

  console.log({ language });

  return (
    <Alert severity="error">
      <Box marginBottom={"0.75rem"}>
        No cfgObjectId set. Please set an cfgObject or select the cfgObject you
        were looking for. When including this application in an iFrame, check
        the url of the iFrame for the correct cfgObjectId.
      </Box>
      <Select
        defaultValue=""
        sx={{ minWidth: "300px", marginBlock: "0.5rem" }}
        onChange={(event) => {
          window.location.href =
            "/?cfgObjectId=" +
            event.target.value +
            "&schnellkonfigurator=" +
            fastConfiguration +
            "&language=" +
            language;
        }}
      >
        {cfgObjects?.map((cfgObject) => {
          return (
            <MenuItem value={cfgObject} key={cfgObject}>
              {cfgObject}
            </MenuItem>
          );
        })}
      </Select>
    </Alert>
  );
}
